import { Icon } from '../shared/icon';

export const ThreatIssueIcon = () => {
  return (
    <Icon
      iconClass='material-symbols-gpp-maybe-outline-rounded'
      color='var(--mui-palette-error-main)'
    />
  );
};
